import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    font-family: 'Montserrat', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
    line-height: 1.6;
    color: #333;
    background-color: #fff;
    letter-spacing: 0.02em;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 400;
    line-height: 1.2;
    margin-bottom: 1rem;
    color: #333;
  }

  h1 {
    font-size: 2.5rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.75rem;
  }

  p {
    margin-bottom: 1.5rem;
  }

  a {
    text-decoration: none;
    color: #d4af37;
    transition: color 0.2s ease;
  }

  a:hover {
    color: #e6c78c;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
    font-family: inherit;
    transition: all 0.2s ease;
  }

  input, textarea {
    font-family: inherit;
    border: 1px solid #e0e0e0;
    padding: 0.75rem 1rem;
    border-radius: 2px;
    transition: border-color 0.2s ease;
  }

  input:focus, textarea:focus {
    outline: none;
    border-color: #d4af37;
  }

  section {
    padding: 4rem 0;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1.5rem;
  }

  /* Responsive typography */
  @media (max-width: 768px) {
    html, body {
      font-size: 14px;
    }
    
    section {
      padding: 3rem 0;
    }
  }
  
  @media (max-width: 576px) {
    section {
      padding: 2rem 0;
    }
  }
`;

export default GlobalStyles;
